/**
 * 5.3.1.2 방화벽 매칭 규칙 Store
 *
 * @since 2017-12-12
 * @author devp020
 */

import {fnGetCodeVal} from '~/utils/admin-common'

const initPamsMatchingData = () => {
  return {
    // --------------- Add Parameter --------------------
    pams_net_rule_id: 0,
    pams_net_rule_bidir_yn: 0,
    pams_net_rule_desc: '',
    pams_net_rule_src_type: 1, // 네트워크 규칙 출발지 유형 1, ANY, 2, ANY(내부망), 3, ANY(외부망), 4, IP/Network, 5, 내부망 그룹(상세설명)
    pams_net_rule_dst_type: 1, // 네트워크 규칙 목적지 유형 1, ANY, 2, ANY(내부망), 3, ANY(외부망), 4, IP/Network, 5, 내부망 그룹(상세설명)
    // pams_net_rule_src_ip: initIpType(),
    pams_net_rule_src_ip: [
      {pams_net_rule_ip_exp: 'ANY'}
    ],
    pams_net_rule_dst_ip: [
      {pams_net_rule_ip_exp: 'ANY'}
    ],
    pams_net_rule_device: [],
    pams_net_rule_src_policy_mng_int_net: [],
    pams_net_rule_dst_policy_mng_int_net: [],
    pams_net_rule_uname: '',
    pams_net_rule_src_type_name: '',
    pams_net_rule_dst_type_name: '',
    ipNetworkGroup: 0
    // --------------------------------------------------
  }
}

export const state = () => ({
  // api url 목록
  apiUrl: {
    pamsNetRuleUrl: '/api/pm/net-rule',
    pamsNetNetUrl: '/api/pm/net-net'
  },
  ipNetworkList: [],
  internalNetwork: [],
  pamsMatchingData: initPamsMatchingData(),
  pamsMatchingSelectedData: {},
  matchRuleList: [],
  matchRuleListFilter: [],
  firewallMatchRuleResult: null,
  errorMessage: null
})

export const mutations = {
  setInternalNetworkList (state, data) {
    const ruleType = data.ruleType
    const result = data.result
    if (result.length > 0) {
      for (let i = 0; i < result.length; i++) {
        result[i].pams_net_rule_ip_exp = result[i].policy_mng_int_net_uname
      }
      if (ruleType === 1) {
        state.pamsMatchingData.pams_net_rule_src_ip = result
      } else if (ruleType === 2) {
        state.pamsMatchingData.pams_net_rule_dst_ip = result
      }
    } else {
      if (ruleType === 1) {
        state.pamsMatchingData.pams_net_rule_src_ip = []
      } else if (ruleType === 2) {
        state.pamsMatchingData.pams_net_rule_dst_ip = []
      }
    }
  },
  setIpNetworkList (state, data) {
    const ruleType = data.ruleType
    const result = data.result
    if (result.length > 0) {
      if (ruleType === 1) {
        state.pamsMatchingData.pams_net_rule_src_ip = result
      } else if (ruleType === 2) {
        state.pamsMatchingData.pams_net_rule_dst_ip = result
      }
    } else {
      if (ruleType === 1) {
        state.pamsMatchingData.pams_net_rule_src_ip = []
      } else if (ruleType === 2) {
        state.pamsMatchingData.pams_net_rule_dst_ip = []
      }
    }
    state.ipNetworkList = result
  },
  setDeviceInfoTable (state, data) {
    state.pamsMatchingData.pams_net_rule_device = data
  },
  setClearPamsMatchingData (state) {
    state.internalNetwork = []
    state.ipNetworkList = []
    state.pamsMatchingData = initPamsMatchingData()
  },
  addObjectData (state, {val, selectedObj}) {
    let objType = void 0
    let cloneItem = void 0
    if (selectedObj === 'src') {
      objType = 'pams_net_rule_src_ip'
    } else if (selectedObj === 'dst') {
      objType = 'pams_net_rule_dst_ip'
    } else if (selectedObj === 'target') {
      objType = 'pams_net_rule_device'
    }
    if (val === 1) {
      cloneItem = getAnyName(1)
    } else if (val === 2) {
      cloneItem = getAnyName(2)
    } else if (val === 3) {
      cloneItem = getAnyName(3)
    }
    state.pamsMatchingData[objType].push(cloneItem[0])
  },
  deleteObjectData (state, {item, objectType}) {
    let objType = void 0
    if (objectType === 'src') {
      objType = 'pams_net_rule_src_ip'
    } else if (objectType === 'dst') {
      objType = 'pams_net_rule_dst_ip'
    } else if (objectType === 'target') {
      objType = 'pams_net_rule_device'
    }
    const selectedObjData = state.pamsMatchingData[objType]
    const itemIndex = _.indexOf(selectedObjData, item)

    selectedObjData.splice(itemIndex, 1)
  },
  setInternalNetwork (state, data) {
    state.internalNetwork = data
  },
  setPamsMatchingClear (state) {
    state.pamsMatchingData = initPamsMatchingData()
  },
  // 선택된 방화벽 매칭 데이터
  setPamsMatchingSelectedData (state, data) {
    state.pamsMatchingData = data
    const srcType = data.pams_net_rule_src_type
    const dstType = data.pams_net_rule_dst_type
    let cloneSrcItem = void 0
    let cloneDstItem = void 0
    if (srcType === 1) {
      cloneSrcItem = getAnyName(1)
    } else if (srcType === 2) {
      cloneSrcItem = getAnyName(2)
    } else if (srcType === 3) {
      cloneSrcItem = getAnyName(3)
    }
    if (dstType === 1) {
      cloneDstItem = getAnyName(1)
    } else if (dstType === 2) {
      cloneDstItem = getAnyName(2)
    } else if (dstType === 3) {
      cloneDstItem = getAnyName(3)
    }
    if (srcType === 1 || srcType === 2 || srcType === 3) {
      state.pamsMatchingData['pams_net_rule_src_ip'].push(cloneSrcItem[0])
    }
    if (dstType === 1 || dstType === 2 || dstType === 3) {
      state.pamsMatchingData['pams_net_rule_dst_ip'].push(cloneDstItem[0])
    }
    if (srcType === 5) {
      const srcIntNet = data.pams_net_rule_src_policy_mng_int_net
      if (srcIntNet.length > 0) {
        for (let i = 0; i < srcIntNet.length; i++) {
          data.pams_net_rule_src_policy_mng_int_net[i].pams_net_rule_ip_exp = srcIntNet[i].policy_mng_int_net_uname
        }
        data.pams_net_rule_src_ip = data.pams_net_rule_src_policy_mng_int_net
      }
      state.pamsMatchingData.ipNetworkGroup = 1
    } else if (srcType === 4) {
      state.ipNetworkList = state.pamsMatchingData.pams_net_rule_src_ip
      state.pamsMatchingData.ipNetworkGroup = 0
    }
    if (dstType === 5) {
      const dstIntNet = data.pams_net_rule_dst_policy_mng_int_net
      if (dstIntNet.length > 0) {
        for (let i = 0; i < dstIntNet.length; i++) {
          data.pams_net_rule_dst_policy_mng_int_net[i].pams_net_rule_ip_exp = dstIntNet[i].policy_mng_int_net_uname
        }
        data.pams_net_rule_dst_ip = data.pams_net_rule_dst_policy_mng_int_net
      }
    }
  },
  // 방화벽 매칭 규칙 조회
  mutMatchRule (state, payload) {
    state.matchRuleList = payload.filter(item => {
      item.pams_net_rule_bidir_yn_name = fnGetCodeVal('pams_net_rule_bidir_yn', item.pams_net_rule_bidir_yn)
      return item
    })
    const data = state.matchRuleList
    for (let i = 0; i < data.length; i++) {
      if (data.length === 0) continue
      const srcType = data[i].pams_net_rule_src_type
      const dstType = data[i].pams_net_rule_dst_type
      let cloneSrcItem = void 0
      let cloneDstItem = void 0
      if (srcType === 1) {
        cloneSrcItem = getAnyName(1)
      } else if (srcType === 2) {
        cloneSrcItem = getAnyName(2)
      } else if (srcType === 3) {
        cloneSrcItem = getAnyName(3)
      }
      if (dstType === 1) {
        cloneDstItem = getAnyName(1)
      } else if (dstType === 2) {
        cloneDstItem = getAnyName(2)
      } else if (dstType === 3) {
        cloneDstItem = getAnyName(3)
      }
      if (srcType === 1 || srcType === 2 || srcType === 3) {
        data[i]['pams_net_rule_src_ip'].push(cloneSrcItem[0])
      }
      if (dstType === 1 || dstType === 2 || dstType === 3) {
        data[i]['pams_net_rule_dst_ip'].push(cloneDstItem[0])
      }
      if (srcType === 5) {
        const srcIntNetInfo = data[i].pams_net_rule_src_policy_mng_int_net
        for (let j = 0; j < srcIntNetInfo.length; j++) {
          data[i].pams_net_rule_src_policy_mng_int_net[j].pams_net_rule_ip_exp = srcIntNetInfo[j].policy_mng_int_net_uname
        }
        data[i].pams_net_rule_src_ip = data[i].pams_net_rule_src_policy_mng_int_net
      }
      if (dstType === 5) {
        const dstIntNetInfo = data[i].pams_net_rule_dst_policy_mng_int_net
        for (let k = 0; k < dstIntNetInfo.length; k++) {
          data[i].pams_net_rule_dst_policy_mng_int_net[k].pams_net_rule_ip_exp = dstIntNetInfo[k].policy_mng_int_net_uname
        }
        data[i].pams_net_rule_dst_ip = data[i].pams_net_rule_dst_policy_mng_int_net
      }
    }
    state.matchRuleListFilter = data
  },
  mutMatchRuleFilter (state, payload) {
    state.matchRuleListFilter = state.matchRuleList.filter((item) => {
      return Object.keys(item).filter(vkey => { return item[vkey].indexOf(payload) >= 0 }).length > 0
    })
  },
  // 방화벽 매칭 규칙 추가
  mutPostFirewallMatchRule (state, payload) {
    state.firewallMatchRuleResult = payload
  },
  // 방화벽 매칭 규칙 수정
  mutPutFirewallMatchRule (state, payload) {
    state.firewallMatchRuleResult = payload
  },
  // 방화벽 매칭 규칙 삭제
  mutDelFirewallMatchRule (state, payload) {
    state.firewallMatchRuleResult = payload
  },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  }
}

export const actions = {
  async applyFwMatchAction () {
    const result = await this.$axios.$put('/api/pm/net-rule/apply', null, {applyMsg: true, loading: true, successAlert: true})
    return result
  },
  async cancelFwMatchAction () {
    const result = await this.$axios.$put(`/api/pm/net-rule/cancel`, null, {cancelMsg: true, loading: true, successAlert: true})
    return result
  },
  // 방화벽 매칭 규칙 빈 설정
  async addBeanNetRule ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(`${state.apiUrl.pamsNetRuleUrl}`, null, {loading: false, loadingShow: false, successAlert: false})
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 방화벽 매칭 규칙 조회
  async acsMatchRule ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${state.apiUrl.pamsNetRuleUrl}/0`, {loading: payload})
      if (res.code === 'ok') {
        commit('mutMatchRule', res.result)
      } else {
        commit('mutMatchRule', [])
      }
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 방화벽 매칭 규칙 수정 항목 조회
  async acsEditMatchRule ({commit, state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${state.apiUrl.pamsNetRuleUrl}/${param}`)
      if (res.code === 'ok') {
        commit('setPamsMatchingSelectedData', res.result[0])
      } else {
        commit('setPamsMatchingSelectedData', {})
      }
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 방화벽 매칭 규칙 추가
  async acsPostFirewallMatchRule ({commit, state}) {
    const result = { error: null }
    const resultParam = {}
    const param = state.pamsMatchingData

    resultParam.pams_net_rule_bidir_yn = param.pams_net_rule_bidir_yn
    resultParam.pams_net_rule_desc = param.pams_net_rule_desc
    resultParam.pams_net_rule_dst_type = param.pams_net_rule_dst_type
    resultParam.pams_net_rule_id = Number(param.pams_net_rule_id)
    resultParam.pams_net_rule_src_type = param.pams_net_rule_src_type
    resultParam.pams_net_rule_uname = param.pams_net_rule_uname
    // {
    //   "pams_net_rule_bidir_yn": 1,
    //   "pams_net_rule_desc": "1H_2.2.2.2",
    //   "pams_net_rule_dst_type": 5,
    //   "pams_net_rule_id": 1,
    //   "pams_net_rule_src_type": 4,
    //   "pams_net_rule_uname": "개발자 PC망2"
    // }
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsNetRuleUrl}`, resultParam, {loading: false, loadingShow: false, successAlert: false})
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 방화벽 매칭 규칙 수정
  async acsPutFirewallMatchRule ({commit, state}, payload) {
    const result = { error: null }
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsNetRuleUrl}/${payload.policy_mng_int_net_id}`, payload, {loading: false, loadingShow: false, successAlert: false})
      commit('mutPutFirewallMatchRule', res)
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 방화벽 매칭 규칙 삭제
  async acsDeleteFirewallMatchRule ({commit, state}, {payload}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const param = {}
      param.pams_net_rule_id_list = payload
      res = await this.$axios.$put(`${state.apiUrl.pamsNetRuleUrl}/${payload[0]}`, param, {loading: true, loadingShow: true, successAlert: false})
      return res
    } catch (error) {
      res.code = 'nok'
      res.result.msg = error.message
      commit('mutationErrorMessage', error)
      return res
    }
  },
  // 대상 방화벽 장비 조회
  async getDeviceInfo ({commit, state}) {
    try {
      const ruleId = state.pamsMatchingData.pams_net_rule_id
      const res = await this.$axios.$get(`${state.apiUrl.pamsNetRuleUrl}/device/${ruleId}`, {loading: false, loadingShow: false, successAlert: false})
      commit('setDeviceInfoTable', res.result)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 대상 방화벽 장비 저장
  async setDeviceInfo ({commit, state}, {deviceIdList}) {
    try {
      const param = {}
      param.pams_net_rule_device_list = deviceIdList
      param.pams_net_rule_id = Number(state.pamsMatchingData.pams_net_rule_id)
      const res = await this.$axios.$post(`${state.apiUrl.pamsNetRuleUrl}/device`, param, {loading: false, loadingShow: false, successAlert: false})
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 대상 방화벽 장비 삭제
  async removeDeviceObj ({commit, state}, {deviceIdList}) {
    try {
      const param = {}
      param.pams_net_rule_device_list = deviceIdList
      param.pams_net_rule_id = Number(state.pamsMatchingData.pams_net_rule_id)
      const res = await this.$axios.$put(`${state.apiUrl.pamsNetRuleUrl}/device`, param, {loading: false, loadingShow: false, successAlert: false})
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 라디오 버튼, 리스트 변경 시 데이터 삭제
  async deleteOtherObjData ({commit, state}, {ruleType, netType}) {
    try {
      const ruleId = Number(state.pamsMatchingData.pams_net_rule_id)
      const res = await this.$axios.$delete(`${state.apiUrl.pamsNetNetUrl}/${ruleId}/${ruleType}/${netType}`, {loading: false, loadingShow: false, successAlert: false})
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 내부 네트워크 설정 조회
  async getInternalNetworkInfo ({commit, state}, {ruleType}) {
    try {
      const ruleId = Number(state.pamsMatchingData.pams_net_rule_id)
      const res = await this.$axios.$get(`${state.apiUrl.pamsNetRuleUrl}/int-net/${ruleId}/${ruleType}`, {loading: false, loadingShow: false, successAlert: false})
      res.ruleType = ruleType
      commit('setInternalNetworkList', res)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 내부 네트워크 설정 추가
  async setInternalNetworkInfo ({commit, state}, {allParams}) {
    try {
      const param = {}
      param.pams_net_rule_id = Number(state.pamsMatchingData.pams_net_rule_id)
      param.pams_net_rule_policy_mng_int_net_list = allParams
      const res = await this.$axios.$post(`${state.apiUrl.pamsNetRuleUrl}/int-net`, param, {loading: false, loadingShow: false, successAlert: false})
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 내부 네트워크 설정 삭제
  async removeInternalNetworkObj ({commit, state}, {allParams}) {
    try {
      const param = {}
      param.pams_net_rule_id = Number(state.pamsMatchingData.pams_net_rule_id)
      param.pams_net_rule_policy_mng_int_net_list = allParams
      const res = await this.$axios.$put(`${state.apiUrl.pamsNetRuleUrl}/int-net`, param, {loading: false, loadingShow: false, successAlert: false})
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // IP/네트워크 추가
  async setIpNetworkRule ({commit, state}, {inputTxt, ruleType}) {
    try {
      const param = {}
      param.pams_net_rule_id = Number(state.pamsMatchingData.pams_net_rule_id)
      param.pams_net_rule_ip_exp = inputTxt
      param.pams_net_rule_ip_type = ruleType
      const res = await this.$axios.$post(`${state.apiUrl.pamsNetRuleUrl}/ip`, param, {loading: false, loadingShow: false, successAlert: false})
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // IP/네트워크 삭제
  async removeIpNetworkObj ({commit, state}, {ruleIpId}) {
    try {
      const param = {}
      param.pams_net_rule_ip_id_list = ruleIpId
      const res = await this.$axios.$put(`${state.apiUrl.pamsNetRuleUrl}/ip`, param, {loading: false, loadingShow: false, successAlert: false})
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // IP/네트워크 리스트 조회
  async getIpNetworkList ({commit, state}, {ruleType}) {
    try {
      const ruleId = Number(state.pamsMatchingData.pams_net_rule_id)
      const res = await this.$axios.$get(`${state.apiUrl.pamsNetRuleUrl}/ip/${ruleId}/${ruleType}`, {loading: false, loadingShow: false, successAlert: false})
      res.ruleType = ruleType
      commit('setIpNetworkList', res)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 내부 네트워크 설정 조회
  async acsInternalNetwork ({commit}) {
    try {
      const res = await this.$axios.$get('/api/pm/int-net/0')
      if (res.code === 'ok') {
        commit('setInternalNetwork', res.result)
      } else {
        commit('setInternalNetwork', [])
      }
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  }
}
export const getters = {}
export const strict = false

function getAnyName (val) {
  const txtName = [
    {
      pams_net_rule_ip_exp: 'ANY',
      pams_check_idx: 0
    }
  ]

  if (val === 2) {
    txtName[0].pams_net_rule_ip_exp = 'ANY(' + window.$nuxt.$t('cmn.internalNetwork') + ')'
  } else if (val === 3) {
    txtName[0].pams_net_rule_ip_exp = 'ANY(' + window.$nuxt.$t('cmn.externalNetwork') + ')'
  }
  return txtName
}
